import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JoyrideModule } from 'ngx-joyride';
import { RouterModule } from '@angular/router';
import { CdkTableModule } from '@angular/cdk/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NouisliderModule } from 'ng2-nouislider';
import { AngularMaterialModule } from './angular-materialmodule';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material';
import { StorageServiceModule } from 'angular-webstorage-service';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ContentWrapperComponent } from './content-wrapper/content-wrapper.component';
import { EnadisComponent } from './enadis/enadis.component';
import { EnadisInfoComponent } from './enadis/enadis-info/enadis-info.component';
import { EnadisExploreComponent } from './enadis/enadis-explore/enadis-explore.component';
import { EnadisGraphsComponent } from './enadis/enadis-graphs/enadis-graphs.component';
import { EnadisCompareComponent } from './enadis-compare/enadis-compare.component';
import { EnadisCompareGraphsComponent } from './enadis-compare/enadis-compare-graphs/enadis-compare-graphs.component';
import { PerfilesComponent } from './perfiles/perfiles.component';

import { ChartContainerComponent } from './components/chart-container/chart-container.component';
import { ChartsSelectionBarComponent } from './components/charts-selection-bar/charts-selection-bar.component';
import { ChartRadioButtonFiltersComponent } from './components/chart-radio-button-filters/chart-radio-button-filters.component';
import { CalendarRangeDatesComponent } from './components/calendar-range-dates/calendar-range-dates.component';
import { CalendarRangeDatesDialogComponent,
  CalendarRangeDatesDialogPopupComponent } from './components/calendar-range-dates-dialog/calendar-range-dates-dialog.component';
import { QuestionDropdownSelectionComponent } from './components/question-dropdown-selection/question-dropdown-selection.component';
import { ErrorCatchDialogComponent } from './dialogs/error-catch-dialog/error-catch-dialog.component';
import { DialogDownloadComponent } from './dialogs/dialog-download/dialog-download.component';
import { DialogAllDataComponent } from './dialogs/dialog-all-data/dialog-all-data.component';
import { DialogMethodologyComponent } from './dialogs/dialog-methodology/dialog-methodology.component';
import { DialogResultsComponent } from './dialogs/dialog-results/dialog-results.component';

import { DataEnadisCompareService } from './services/data-enadis-compare/data-enadis-compare.service';
import { DataEnadisService } from './services/data-enadis/data-enadis.service';
import { FilterRadiobuttonPopupComponent } from './components/filter-radiobutton-popup/filter-radiobutton-popup.component';
import { UtilsService } from './services/utils/utils.service';
import { EndosigComponent } from './endosig/endosig.component';
import { EndosigInfoComponent } from './endosig/endosig-info/endosig-info.component';
import { EndosigExploreComponent } from './endosig/endosig-explore/endosig-explore.component';
import { EndosigGraphsComponent } from './endosig/endosig-graphs/endosig-graphs.component';
import { DataEndosigService } from './services/data-endosig/data-endosig.service';
import { SimpleChartComponent } from './components/simple-chart/simple-chart.component';

@NgModule({
  declarations: [
    AppComponent,
    ContentWrapperComponent,
    EnadisComponent,
    EnadisInfoComponent,
    EnadisExploreComponent,
    EnadisGraphsComponent,
    EndosigComponent,
    EndosigInfoComponent,
    EndosigExploreComponent,
    EndosigGraphsComponent,
    DialogMethodologyComponent,
    DialogResultsComponent,
    DialogAllDataComponent,
    ErrorCatchDialogComponent,
    DialogDownloadComponent,
    EnadisCompareComponent,
    EnadisCompareGraphsComponent,
    ChartContainerComponent,
    SimpleChartComponent,
    ChartsSelectionBarComponent,
    ChartRadioButtonFiltersComponent,
    CalendarRangeDatesComponent,
    CalendarRangeDatesDialogComponent,
    CalendarRangeDatesDialogPopupComponent,
    PerfilesComponent,
    QuestionDropdownSelectionComponent,
    FilterRadiobuttonPopupComponent
  ],
  imports: [
    JoyrideModule.forRoot(),
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AngularMaterialModule,
    HttpClientModule,
    NouisliderModule,
    StorageServiceModule
  ],
  entryComponents: [
    DialogMethodologyComponent,
    DialogResultsComponent,
    DialogAllDataComponent,
    ErrorCatchDialogComponent,
    DialogDownloadComponent,
    CalendarRangeDatesDialogPopupComponent,
    EnadisExploreComponent,
    EnadisGraphsComponent,
    EndosigExploreComponent,
    EndosigGraphsComponent,
    ChartsSelectionBarComponent,
    EnadisCompareGraphsComponent,
    QuestionDropdownSelectionComponent,
    FilterRadiobuttonPopupComponent
  ],
  providers: [
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
    DataEnadisService,
    DataEndosigService,
    DataEnadisCompareService,
    UtilsService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts